module.exports = __webpack_public_path__ + "assets/img/003.7b1fdf9c.png";